import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum ModalType {
  VIDEO = "VIDEO",
  INFO = "INFO",
}

export interface ModalData {
  featureId?: string;
  videoUrl?: string;
  videoUrlMobile?: string;
  title?: string;
  content?: string;
  imageUrl?: string;
}

export interface ModalState {
  isOpen: boolean;
  modalType: ModalType | null;
  modalProps: ModalData;
}

const initialState: ModalState = {
  isOpen: false,
  modalType: null,
  modalProps: {},
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: {
      prepare(type: ModalType, props: ModalData) {
        return { payload: { type, props } };
      },

      reducer(
        state,
        action: PayloadAction<{ type: ModalType; props: ModalData }>,
      ) {
        state.isOpen = true;
        state.modalType = action.payload.type;
        state.modalProps = action.payload.props || {};
      },
    },
    closeModal(state) {
      state.isOpen = false;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
